import GOFModel from '../models/GOFModel'
import TemplateModel from '../models/TemplateModel'
import { GOF } from '../types'

export const createGOFModel = (gof: GOF, template: TemplateModel): GOFModel =>
   new GOFModel(gof, template)

export const updateGof = (gofModel: GOFModel, gof: GOF): void => {
   if (gof.name) gofModel.name = gof.name
   if (gof.description) gofModel.description = gof.description
   if (gof.orderedFieldIds.length)
      gofModel.setOrderedFieldIds(gof.orderedFieldIds)
   if (gof.gofCategory) gofModel.gofCategory = gof.gofCategory
}
